import classNames from "classnames";
import styles from "./TableInputGroup.module.scss";

function TableInputGroup({
  children,
  header,
  footer,
  className,
}: {
  children?: React.ReactNode;
  header: React.ReactNode;
  footer?: React.ReactNode;
  className?: {
    container?: string;
    header?: string;
    inputs?: string;
  };
}) {
  return (
    <div className={classNames(styles.container, className?.container)}>
      <div className={classNames(styles.header, className?.header)}>
        {header}
      </div>
      <div className={classNames(styles.inputs, className?.inputs)}>
        {children}
      </div>
      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
}

export default TableInputGroup;
